import moment from 'moment-timezone';

const FormUtils = {
  booleanToString: input => ((typeof input === 'boolean') ? input.toString() : ''),
  yesNoToBoolean: (input) => {
    let result = null;
    if (input === 'Yes') {
      result = true;
    } else if (input === 'No') {
      result = false;
    }
    return result;
  },
  booleanToYesNo: (input) => {
    let result = '';
    if (input === true) {
      result = 'Yes';
    } else if (input === false) {
      result = 'No';
    }
    return result;
  },
  formatNumber: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
  parseNumber: (value) => {
    if (value === '' || value == null || typeof value === 'undefined') {
      return null;
    }

    return Number(`${value}`.replace(/(,|\s)/g, ''));
  },
  filterOptions: (userInput, optionComponent) => {
    const optionText = optionComponent.props.children;
    return `${optionText}`.toLowerCase().indexOf(userInput.toLowerCase()) >= 0;
  },
  regex: {
    phone: /^\d{3}-\d{3}-\d{4}$/,
    email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    positiveInt: /^[0-9]+$/,
    currency: /^[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/,
    password: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/,
    networkPassword: /^(?=.*?[A-Z])(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?!.*\s).{4,}$/,
  },
  futureDates: current => current && current > moment().endOf('day'),
  pastDates: current => current && current < moment().startOf('day'),
  beforeDate: target => current => current && current.format('YYYY-MM-DD') <= target,
  getSelectDisplayText: (itemList, displayTextProperty, lookupProperty, lookupValue) => {
    const foundItem = itemList.find(item => item[lookupProperty] === lookupValue);
    if (foundItem && foundItem[displayTextProperty]) {
      return foundItem[displayTextProperty];
    }
    return '';
  },
  fixChromeAutofill: (c) => {
    setTimeout(() => { if (c && c.input) c.input.setAttribute('autoComplete', 'new-password'); }, 500);
  },
  // This fixes windows special characters that come from copy / pasting from ms office apps
  mapMsOfficeChars: (stringIn) => {
    let rawString = stringIn || '';

    rawString = rawString.replace(/–/g, '-');
    rawString = rawString.replace(/—/g, '-');
    rawString = rawString.replace(/‘/g, "'");
    rawString = rawString.replace(/’/g, "'");
    rawString = rawString.replace(/‚/g, ',');
    rawString = rawString.replace(/“/g, '"');
    rawString = rawString.replace(/”/g, '"');
    rawString = rawString.replace(/„/g, ',');
    rawString = rawString.replace(/…/g, '...');
    rawString = rawString.replace(/‰/g, '%');
    rawString = rawString.replace(/˜/g, '~');

    /* remove windows zero width chars
      U+200B zero width space
      U+200C zero width non-joiner Unicode code point
      U+200D zero width joiner Unicode code point
      U+FEFF zero width no-break space Unicode code point
      U+200E zero width left to right mark
      U+200F zero width right to left */
    rawString = rawString.replace(/[\u200B-\u200D\uFEFF\u200E\u200F]/g, '');

    return rawString;
  },
};

export default FormUtils;
